import React, { HTMLProps } from 'react';

import styles from './searchLanguageItem.module.scss';

export interface SearchCurrencyItemProps extends HTMLProps<HTMLDivElement> {
  name: string;
  icon: string;
  code: string;
  selectedItem: string | undefined;
}

export const SearchLanguageItem = ({ name, icon, code, selectedItem, ...divProps }: SearchCurrencyItemProps) => {
  return (
    <div {...divProps} className={selectedItem === code ? `${styles.container} ${styles.selected}` : styles.container}>
      <div className={styles['icon-column']}><img className="flag-icon" src={icon} /></div>
      <span className={styles.title}>{name}</span>
      {selectedItem === code && <span className={styles.tick}>&#x2713;</span>}
    </div>
  );
};
